const moduleRegistry = new Map();

export const registerModule = (name, loader) => moduleRegistry.set(name, loader);
export const unregisterModule = (name) => moduleRegistry.delete(name);

const dynamicImport = async (name) => {
    if (!moduleRegistry.has(name)) return Promise.resolve();
    const module = await moduleRegistry.get(name)();
    
    return module?.default ?? module
}

// eslint-disable-next-line no-new-func
export const safeEval = fn => (Function('dynamicImport', `return (${fn});`))(dynamicImport)
